<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M15.8332 9.99984H4.1665M4.1665 9.99984L9.99984 15.8332M4.1665 9.99984L9.99984 4.1665"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
        />
    </svg>
</template>
